import {
  createSlice,
} from "@reduxjs/toolkit";


import { createProjectThunk} from "./projectForm.actions";
import { ProjectData } from "types";
import { StatusState } from "store/types";

interface ProjectFormCreationState {
  data: ProjectData | null;
  statusState:StatusState;
  error: string | null;
  successMessage: string | null;
}

const initialState: ProjectFormCreationState = {
  data: null,
  statusState: StatusState.IDLE,
  error: null,
  successMessage: null,
};

export const projectFormSlice = createSlice({
  name: "projectForm",
  initialState,
  reducers: {
    resetProjectFormState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(createProjectThunk.pending, (state) => {
        state.statusState = StatusState.LOADING;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(createProjectThunk.fulfilled, (state) => {
        state.statusState = StatusState.SUCCEEDED;
        state.successMessage = "Project created successfully";
      })
      .addCase(createProjectThunk.rejected, (state, action) => {
        state.statusState = StatusState.FAILED;
        state.error = action.payload as string;
      })
  },
});

export const { resetProjectFormState } = projectFormSlice.actions;

const projectFormReducer = projectFormSlice.reducer
export default projectFormReducer;
